var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('HomeCarousel',{staticClass:"carousel-web"}),_c('HomeCarouselMobile',{staticClass:"carousel-mobile"}),_c('HomeProduct'),_c('HomeAbout'),_c('HomeSourceCenter'),_c('HomeNews'),_c('HomeCooperate')],1)}
var staticRenderFns = []

export { render, staticRenderFns }